// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__R5BcI","label":"Radio_label__I77iB","checkMark":"Radio_checkMark__34CM0","disabled":"Radio_disabled__wZrY7"};